import React, { useEffect, useRef } from 'react';

export function TextArea({ 
    value, 
    onChange, 
    placeholder, 
    minRows = 3, 
    autoResize = true,
    className = '',
    ...props 
}) {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (autoResize && textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [value, autoResize]);

    return (
        <textarea
            ref={textareaRef}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            rows={minRows}
            className={`
                w-full bg-[var(--bg-surface)] border border-[var(--border)] rounded-lg 
                px-3 py-2.5 text-sm text-[var(--text-primary)] placeholder-[var(--text-tertiary)]
                focus:outline-none focus:border-[var(--accent)] focus:ring-1 focus:ring-[var(--accent)]
                transition-all resize-none
                ${className}
            `}
            {...props}
        />
    );
}
